import React from 'react';
import Box from '@amzn/meridian/box';

import './flowPlannerShared.css';

const ConfigPanel = ({ joined = false, className, children }) => {
  const cls = `fp-theme${className ? ` ${className}` : ''}`;
  if (joined) return <div className={cls}>{children}</div>;
  return (
    <Box type="outline" spacingInset="300" className={cls} style={{ backgroundColor: 'white', width: '100%' }}>
      {children}
    </Box>
  );
};

export default ConfigPanel;
